import { useQuery } from "react-query";
import authAPI from "../authAPI";

export const useFeideWhitelist = (id, options = {}) => {
  return useQuery(
    ["feideWhitelist", id],
    async () => {
      const result = await authAPI.getFeideWhitelist(id);
      return result;
    },
    {
      enabled: !!id,
      ...options,
    }
  );
};
